import React from 'react';

interface Props {
  className?: string;
}

export const IconProfile: React.FC<Props> = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.49 19.8892L7.87 16.7826L1.52 19.8575C1.36868 19.9305 1.1956 19.9703 1.01848 19.9729C0.841353 19.9755 0.666535 19.9408 0.511913 19.8723C0.357292 19.8037 0.228415 19.7039 0.13847 19.5829C0.0485242 19.462 0.00073824 19.3243 1.08833e-06 19.1839L6.92822e-08 1.58499C5.09074e-08 1.16463 0.210714 0.761477 0.585787 0.464234C0.96086 0.16699 1.46957 -6.42368e-08 2 -8.74228e-08L14 -6.11959e-07C14.5304 -6.35145e-07 15.0391 0.166989 15.4142 0.464233C15.7893 0.761477 16 1.16463 16 1.58499L16 19.2076C16 19.3475 15.9532 19.4849 15.8645 19.6058C15.7758 19.7268 15.6483 19.8269 15.4949 19.8961C15.3415 19.9654 15.1678 20.0012 14.9913 20C14.8148 19.9987 14.6418 19.9605 14.49 19.8892Z"
        fill="#725CFF"
      />
      <path
        d="M9.77174 11.9887H10.9891L11 5H9.78261V9.91923L6.22826 5H5V12H6.22826V7.08078L9.77174 11.9887Z"
        fill="white"
      />
    </svg>
  );
};

export default IconProfile;
